import { Modal, Input } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { message } from '@icp/settings';
import { useTranslation } from 'react-i18next';
import { commit } from './utils';

const { TextArea } = Input;

function CommitDialog(props) {
  const { t } = useTranslation(['icp-components', 'icp-common']);
  const { projectId, type, data, onClose } = props;
  const [commitMessage, setCommitMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await commit(projectId, type, commitMessage, data);
      setCommitMessage('');
      message.success(t('commit-content.submit-success'));
      onClose();
    } catch (error) {
      message.error(t('commit-content.submit-failure'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={true}
      title={t('commit-content.title')}
      onOk={handleSubmit}
      okText={t('submit', { ns: 'icp-common' })}
      okButtonProps={{
        disabled: !commitMessage.trim(),
        loading: isSubmitting,
      }}
      onCancel={onClose}
      maskClosable={false}
      cancelButtonProps={{
        disabled: isSubmitting,
      }}
    >
      <TextArea
        className="icp-thin-scrollbar"
        placeholder={t('commit-content.message-placeholder')}
        style={{ height: 120, resize: 'none' }}
        value={commitMessage}
        onChange={(e) => setCommitMessage(e.target.value)}
      />
    </Modal>
  );
}

CommitDialog.propTypes = {
  type: PropTypes.string,
  data: PropTypes.shape({}),
  projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func,
};

export default CommitDialog;
